import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import StopIcon from '@mui/icons-material/Stop';
import "./SwipeButton.css"

const SwipeButton = ({ onStop, isPaused, isStopped, isRecording }) => {
  const [dragging, setDragging] = useState(false);
  const [positionX, setPositionX] = useState(0); // Current button position
  const sliderRef = useRef(null);

  let sliderWidth = 360; // Width of the slider
  const buttonSize = 66;   // Size of the button

  const handleDragStart = () => {
    setDragging(true);
  };

  const handleSwipe = (clientX) => {
    if (!dragging) return;

    const sliderLeft = sliderRef.current.getBoundingClientRect().left; // Left edge of slider
    const newPosition = clientX - sliderLeft - buttonSize / 2; // Calculate new button position

    // Restrict button movement within slider boundaries
    if (newPosition >= 0 && newPosition <= sliderWidth - buttonSize) {
      setPositionX(newPosition);
    }
  };

  const handleMouseMove = (event) => {
    handleSwipe(event.clientX);
  };

  const handleTouchMove = (event) => {
    handleSwipe(event.touches[0].clientX); // Touch events use `touches[0]` to get the touch point
  };

  const handleDragEnd = () => {
    setDragging(false);

    // Snap to leftmost if dragged less than 50%, otherwise rightmost
    if (positionX < (sliderWidth - buttonSize) / 2) {
      setPositionX(0); // Snap to left
    } else {
      setPositionX(sliderWidth - buttonSize); // Snap to right
      onStop(); // Trigger stop action
    }
  };

  useEffect(() => {
    sliderWidth = document.getElementsByClassName("SwipeButton_Main")?.[0]?.clientWidth;
  }, []);

  return (
   <>
    <Box
      ref={sliderRef}
      sx={{
        height: 60,
        backgroundColor: positionX === sliderWidth - buttonSize ? 'red' : 'gray',
        borderRadius: 30,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        userSelect: 'none', // Prevent text selection while dragging
        justifyContent:  positionX === sliderWidth - buttonSize ? "center" : "flex-end",
        paddingRight:positionX === sliderWidth - buttonSize ? "" : "28px",
        boxSizing:"border-box"
      }}
      className="SwipeButton_Main"
      onMouseMove={dragging ? handleMouseMove : null}
      onTouchMove={dragging ? handleTouchMove : null} // Handle touch move for mobile
      onMouseUp={handleDragEnd}
      onTouchEnd={handleDragEnd} // Handle touch end for mobile
      onMouseLeave={handleDragEnd}
    >
      {isStopped
        ? <Typography color={"white"}>Recording Stopped</Typography>
        : ""
      }
      {positionX !== sliderWidth - buttonSize && (
        <Box
          sx={{
            width: buttonSize,
            height: buttonSize,
            borderRadius: '50%',
            position: 'absolute',
            left: `${positionX}px`, // Dynamically position the button based on state
            backgroundColor: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
            cursor: 'grab',
            '&:hover': {
              backgroundColor: 'lightgray',
            },
          }}
          onMouseDown={handleDragStart}
          onTouchStart={handleDragStart} // Handle touch start for mobile
        >
          <StopIcon fontSize="large" sx={{ color: 'black' }} />
        </Box>
      )}
    </Box>
   {(isRecording || isPaused) && <Typography variant='caption'>Swipe to Stop Recording</Typography>}
   </>
  );
};

export default SwipeButton;
